var React = require('react');

function Desktop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m48.5 11.7h-37c-1.5 0-2.8 1.2-2.8 2.8v24.1c0 1.5 1.2 2.8 2.8 2.8h14.9v2.5h-3.5c-.9 0-1.6.7-1.6 1.6v1.5c0 .9.7 1.6 1.6 1.6h14.1c.9 0 1.6-.7 1.6-1.6v-1.5c0-.9-.7-1.6-1.6-1.6h-3.5v-2.5h14.9c1.5 0 2.8-1.2 2.8-2.8v-24.2c0-1.5-1.2-2.7-2.7-2.7zm-11.4 33.6v1.5h-14.2v-1.5zm-9.1-1.6v-2.5h4v2.5zm21.4-4.6c0 .2-.2.4-.4.4h-38c-.2 0-.4-.2-.4-.4v-2.8h38.8zm0-3.7h-38.8v-21.2c0-.2.2-.4.4-.4h38c.2 0 .4.2.4.4z","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2"}));
}

Desktop.defaultProps = {"viewBox":"0 0 60 60"};

module.exports = Desktop;

Desktop.default = Desktop;
